import React from 'react'

export default function SoundbankB() {
    
    return (
        <>
            <span className='soundbank-a inactive-sound' id='A'>A</span>
            <span className='soundbank-divider inactive-sound'>-</span>
            <span className='soundbank-b active-sound' id='B'>B</span>
        </>
    )

}